import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[layerControlPreview]',
  standalone:true
})
export class LayerControlPreviewDirective {

  constructor(public templateRef: TemplateRef<any>) {}

}
